import type {AjaxService} from 'core/data-services/ajax.service';
import type {SutorEmployeeDetail} from './types';

export class EmployeeRecordDetailDataService {
    public static serviceName = 'employeeRecordDetailDataService';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async getUserDetailData(userId: string): Promise<SutorEmployeeDetail> {
        return this.ajaxService
            .createRequest(`/employee/detail/${userId}`)
            .get();
    }
}